import { CheckAvailableCreditCTA } from "./ctas";
export var BrandReferralUseCreditIA = function BrandReferralUseCreditIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize), BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return CheckAvailableCreditCTA(strictLocalize);
};
var BRAND_REFERRALS_USE_CREDIT_TITLE = function BRAND_REFERRALS_USE_CREDIT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "zvQaIx",
    defaultMessage: [{
      "type": 0,
      "value": "Zo gebruik je het tegoed van merkdoorverwijzingen"
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "dkqwac",
    defaultMessage: [{
      "type": 0,
      "value": "Nadat je je tegoed hebt ontvangen, wordt het automatisch toegepast op je volgende bestelling bij een merk. Je hoeft niets te doen. Als je niet al je tegoed in één keer opgebruikt, wordt het resterende bedrag doorgeschoven. Om te controleren hoeveel tegoed je nog hebt, ga je naar ‘Beschikbaar tegoed’ in ‘Account’."
    }]
  });
};
var BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2 = function BRAND_REFERRALS_USE_CREDIT_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "DthCDL",
    defaultMessage: [{
      "type": 0,
      "value": "Als je benieuwd bent naar hoeveel tegoed je hebt verdiend met het doorverwijzen van merken, ga je naar ‘Merken doorverwijzen’ in ‘Account’ en selecteer je het tabblad ‘Geregistreerd’."
    }]
  });
};